import React, { useState } from 'react';
import { CheckIcon, BarChart3Icon, UsersIcon, ZapIcon } from 'lucide-react';
import Button from './Button';
import Wizard from './Wizard';
import { useTranslation } from '../i18n/useTranslation';
const ValueProps = () => {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const {
    t
  } = useTranslation();
  return <section id="value-props" className="py-16 bg-gray-50" data-id="element-2298">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2299">
        <div className="text-center mb-12" data-id="element-2300">
          <h2 className="text-3xl font-bold mb-4" data-id="element-2301">
            {t('sections.valueProps.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-2302">
            {t('sections.valueProps.subtitle')}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-2303">
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2304">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2305">
              <BarChart3Icon className="h-8 w-8 text-primary" data-id="element-2306" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2307">
              {t('sections.valueProps.conversion.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2308">
              {t('sections.valueProps.conversion.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2309">
              <div className="flex items-center justify-between" data-id="element-2310">
                <span className="text-gray-600" data-id="element-2311">
                  {t('sections.valueProps.conversion.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2312">+27%</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2313">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2314">
              <UsersIcon className="h-8 w-8 text-primary" data-id="element-2315" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2316">
              {t('sections.valueProps.aov.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2317">
              {t('sections.valueProps.aov.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2318">
              <div className="flex items-center justify-between" data-id="element-2319">
                <span className="text-gray-600" data-id="element-2320">
                  {t('sections.valueProps.aov.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2321">+32%</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2322">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-2323">
              <ZapIcon className="h-8 w-8 text-primary" data-id="element-2324" />
            </div>
            <h3 className="text-2xl font-bold mb-4" data-id="element-2325">
              {t('sections.valueProps.returns.title')}
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-2326">
              {t('sections.valueProps.returns.description')}
            </p>
            <div className="border-t border-gray-100 pt-4" data-id="element-2327">
              <div className="flex items-center justify-between" data-id="element-2328">
                <span className="text-gray-600" data-id="element-2329">
                  {t('sections.valueProps.returns.metric')}
                </span>
                <span className="text-2xl font-bold text-primary" data-id="element-2330">-18%</span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl p-8 shadow-card border border-gray-100" data-id="element-2331">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-2332">
            <div data-id="element-2333">
              <h3 className="text-2xl font-bold mb-4" data-id="element-2334">
                {t('sections.valueProps.advantage.title')}
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-2335">
                {t('sections.valueProps.advantage.description')}
              </p>
              <ul className="space-y-3 mb-6" data-id="element-2336">
                <li className="flex items-start" data-id="element-2337">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2338" />
                  <span className="ml-3 text-gray-600" data-id="element-2339">
                    {t('sections.valueProps.advantage.features.catalog')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2340">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2341" />
                  <span className="ml-3 text-gray-600" data-id="element-2342">
                    {t('sections.valueProps.advantage.features.sales')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2343">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2344" />
                  <span className="ml-3 text-gray-600" data-id="element-2345">
                    {t('sections.valueProps.advantage.features.channels')}
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2346">
                  <CheckIcon className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" data-id="element-2347" />
                  <span className="ml-3 text-gray-600" data-id="element-2348">
                    {t('sections.valueProps.advantage.features.analytics')}
                  </span>
                </li>
              </ul>
              <Button variant="primary" size="lg" onClick={() => setIsWizardOpen(true)} data-id="element-2349">
                {t('buttons.getStarted')}
              </Button>
            </div>
            <div className="bg-gray-50 rounded-xl p-6" data-id="element-2350">
              <div className="text-xl font-bold mb-4" data-id="element-2351">
                {t('sections.valueProps.testimonial.title')}
              </div>
              <p className="text-gray-600 italic mb-4" data-id="element-2352">
                "{t('sections.valueProps.testimonial.quote')}"
              </p>
              <div className="flex items-center" data-id="element-2353">
                <div className="w-12 h-12 bg-gray-200 rounded-full mr-4" data-id="element-2354"></div>
                <div data-id="element-2355">
                  <div className="font-bold" data-id="element-2356">
                    {t('sections.valueProps.testimonial.name')}
                  </div>
                  <div className="text-gray-500 text-sm" data-id="element-2357">
                    {t('sections.valueProps.testimonial.position')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Wizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-2358" />
    </section>;
};
export default ValueProps;